import { InformationOutline24Icon } from "@vygruppen/spor-icon-react";
import { PreviewStatus } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/infrastructureEventModal/Preview";
import { PreviewExample } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/infrastructureEventModal/PreviewExample";
import { PreviewResponse } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/utils";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Title } from "shared/components/feedback/InfoMessage/ExpandableInfoMessage/ExpandableButton";
import { Flex, Tooltip } from "shared/components/Spor";

type PreviewListProps = {
  previewStatus: PreviewStatus;
  previewData: PreviewResponse[] | undefined;
};

export const PreviewList: FC<PreviewListProps> = ({
  previewData = [],
  previewStatus,
}) => {
  const { t } = useTranslation();
  const previewExampleInternal = previewData.map((it) => ({
    context: it.internalContext,
    title: it.internalTitle,
    message: it.internalMessage,
  }));
  const previewExampleExternal = previewData.map((it) => ({
    context: it.externalContext,
    title: it.externalTitle,
    message: it.externalMessage,
  }));
  return (
    <Flex direction="column" gap="6px">
      <Flex gap="6px" alignItems="center">
        <Title>{t("Informasjon som sendes ut")}</Title>
        <Tooltip
          hasArrow
          label={t(
            "Dette er en oppsummering av informasjon som sendes ut om denne hendelsen. Ordlyden tilpasses etter mottaker.",
          )}
          placement="top"
        >
          <InformationOutline24Icon />
        </Tooltip>
      </Flex>
      <PreviewExample
        previewExample={previewExampleInternal}
        previewStatus={previewStatus}
        source="INTERNAL"
      />
      <PreviewExample
        previewExample={previewExampleExternal}
        previewStatus={previewStatus}
        source="EXTERNAL"
      />
    </Flex>
  );
};
